import { render } from "./NewPost.vue?vue&type=template&id=45b2ec25&scoped=true"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"

import "./NewPost.vue?vue&type=style&index=0&id=45b2ec25&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b2ec25"]])

export default __exports__